
import { Action } from '@ngrx/store';

import * as BeneficiaryDetailsAction from './../actions/beneficiary-details.actions';
import { BeneficiaryDetails } from 'src/app/model/ngrx';

export type Actions = BeneficiaryDetailsAction.Actions;

const initialState: BeneficiaryDetails = {
    userTitle:'',
    otherTitle:'',
    forename: '',
    surname: '',
    ukAddressIndicator:'',
    beneficiaryAllocPercentage:0,
    dateOfBirth: '',
    address: {
        addressline1: '',
        addressline2:'',
        addressline3: '',
        addressline4: '',
        postcode: '',
        countryCode:''
    }
   
    
};



export function BeneficiaryDetailsReducer(state: BeneficiaryDetails[] = [initialState], action: BeneficiaryDetailsAction.Actions) {
    switch (action.type) {
        case BeneficiaryDetailsAction.ADD_BENEFICIARY_DETAILS:
            return [...state, action.payload];
        
        case BeneficiaryDetailsAction.REMOVE_BENEFICIARY_DETAILS:
            state = [];
            return state;

        default:
            return state;
    }
}
